export default (params) => ({
  trigger: {
    name: 'content_blocks.comparison.click_next_previous',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      visible_indices: {
        type: 'integer',
      },
      visible_items: {
        type: 'string',
      },
      direction: {
        enum: [
          'next',
          'previous',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_direction',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
